"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nl2br = void 0;
/**
 * Adds <br /> for new lines in a string
 *
 * @param string The multi line string to add <br /> tags to
 */
exports.nl2br = (string) => {
    return string.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
};
//# sourceMappingURL=nl2br.js.map